export const download = {
  accessButton: "Acceder",
  downloadButton: "Descargar",
  webDesc: "Accedé al sitio web en tu navegador",
  windowsDesc: "Descargá el instalador para Windows",
  linuxDesc: "Descargá el instalador para Linux",
  androidDesc: "Descargá el APK para Android",
  iosDesc: "Descargá la app para iOS",
  title: "Descargá la app",
  subtitle:
    "Accedé a Araria en cualquier lugar, en tu navegador, computadora o en tu smartphone",
};
